import React, { useEffect, useState } from "react";
import { getPlatform1, getPlatform2 } from "../../api/commonApi";

const PlatformUsage = ({id}) => {
  const [platformData, setPlatformData] = useState([]);

  useEffect(() => {
    const fetchPlatforms = async () => {
      try {
        const [p1, p2] = await Promise.all([getPlatform1(), getPlatform2()]);

        const data = [
          {
            img: p1?.data?.imageUrl || "",
            title: p1?.data?.heading || "",
            desc: p1?.data?.content1 || "",
            reverse: false,
          },
          {
            img: p2?.data?.imageUrl || "",
            title: p2?.data?.heading || "",
            desc: p2?.data?.content1 || "",
            reverse: true,
          },
        ];
        setPlatformData(data);
      } catch (err) {
        console.error("Error fetching platform data", err);
      }
    };

    fetchPlatforms();
  }, []);

  return (
    <section id={id} className="flex flex-col min-h-screen bg-[#FFF9EE]">
  <div className="relative flex items-center justify-center mb-16">
  {/* Gradient Line */}
  <div className="w-full h-[1px] bg-[linear-gradient(to_right,#FBFAF1,#87004C,#FBFAF1)]"></div>

  {/* Center Label */}
  <span className="absolute px-6 py-2 rounded-full bg-[linear-gradient(to_right,#DFC355,#FDF880,#ECDA68)] text-[#87004C] text-sm font-medium shadow">
 To Book Our PG, Download Avita PG App
  </span>
</div>
      
       
      
      <main className="flex-1 max-w-6xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-bold text-center mb-12">
          <span className="heading-style text-[#87004C]">Platform</span>{" "}
          <span className="heading-style text-black">Usage</span>
        </h1>
        <div className="flex flex-col gap-20">
          {platformData.map((item, idx) => (
            <div
              key={idx}
              className={`flex flex-col md:flex-row items-center gap-12 ${
                item.reverse ? "md:flex-row-reverse" : ""
              }`}
            >
              <div className="flex-1 flex justify-center">
                <img
                  src={item.img}
                  alt={item.title}
                  className="max-w-xs"
                />
              </div>
              <div className="flex-1 text-center md:text-left">
                <h2 className="text-lg font-bold mb-2">{item.title}</h2>
                <div
                  className="text-gray-600"
                  dangerouslySetInnerHTML={{ __html: item.desc }}
                />
              </div>
            </div>
          ))}
        </div>
      </main>
    </section>
  );
};

export default PlatformUsage;
